import { EditorsChoice, SectionTitle, Stats } from '@sloyd/ui';
import { Content, Item, Name, Top, Wrapper } from './ContentGoldens.style';

export type ContentGoldensProps = {
  generators: IGenerator[];
  stats: Json[];
  callbacks: {
    onOpenGenerator: (id: string) => void;
    onManageGolden: (id: string) => void;
  };
};

export function ContentGoldens(props: ContentGoldensProps) {
  const { generators, stats, callbacks } = props;

  function renderGenerator(g: IGenerator) {
    const { goldens = [] } = g;

    function onClick(index: number) {
      const golden = goldens[index];
      if (!golden) return;
      callbacks.onManageGolden(golden.id);
    }

    return (
      <Item key={g.id} className='g'>
        <Name onClick={() => callbacks.onOpenGenerator(g.id)}>
          {g.id} {g.name}
        </Name>
        <EditorsChoice onClick={onClick} slim total={goldens.length} />
      </Item>
    );
  }

  function renderGenerators() {
    return generators.map((g: IGenerator) => renderGenerator(g));
  }

  return (
    <Wrapper className='ContentGoldens-wrapper' data-testid='ContentGoldens-wrapper'>
      <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Goldens Admin'>
        Manage what will be shown in browse ideas, examples and more.
      </SectionTitle>
      <Top>
        <Stats data={stats} />
      </Top>
      <Content>{renderGenerators()}</Content>
    </Wrapper>
  );
}

export default ContentGoldens;
